import { useRouter } from "@tanstack/react-router"

import { useShowSubmission } from "@/modules/helpers/hooks/shared/use-show-submission"
import { redirectLinkNotification } from "@/modules/helpers/hooks/use-notification-redirect"
import { getSubmissionIdFromNotification } from "@/modules/helpers/utils/notification"
import { Notification } from "@/modules/types"

export const useNotificationAction = () => {
  const router = useRouter()
  const { setId } = useShowSubmission()

  const handleNotificationClick = (data: Notification) => {
    // 1. Check if it's a submission/draft type that needs to open a modal
    const submissionId = getSubmissionIdFromNotification(data)
    if (submissionId) {
      setId(submissionId)
      return
    }

    // 2. Check if it's a redirect type
    const redirectData = redirectLinkNotification(data)

    if (redirectData) {
      if (typeof redirectData === "string") {
        router.navigate({ to: redirectData })
      } else {
        router.navigate(redirectData)
      }
    }
  }

  return {
    handleNotificationClick
  }
}
